export const hasValue = value => value !== null && value !== undefined &&
  (typeof value !== 'string' || value.trim() !== '');

export const displayValue = value => !hasValue(value) ? 'Not recorded' :
  typeof value === 'object' ? JSON.stringify(value) : String(value);

export const formatScreeningDate = value => {
  if (!value) return 'Not recorded';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? 'Not recorded' : new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium', timeStyle: 'short'
  }).format(date);
};

export const hasSavedAnswer = response => !!response && (hasValue(response.response) ||
  (Array.isArray(response.selected_options) && response.selected_options.length > 0) || hasValue(response.rating));

export const questionRows = screening => {
  const questions = Array.isArray(screening?.questions_snapshot) ? screening.questions_snapshot : [];
  const responses = Array.isArray(screening?.responses) ? screening.responses : [];
  const used = new Set();
  const rows = questions.filter(Boolean).map((question, index) => {
    const responseIndex = responses.findIndex((response, i) => response && !used.has(i) &&
      (question.id ? response.question_id === question.id : question.question_text && response.question_text === question.question_text));
    if (responseIndex >= 0) used.add(responseIndex);
    return { question, response: responses[responseIndex] || null, key: `question-${question.id || index}-${index}` };
  });
  responses.forEach((response, index) => {
    if (!response || used.has(index)) return;
    rows.push({ question: { id: response.question_id, question_text: response.question_text || 'Original question unavailable',
      question_type: response.question_type }, response, key: `saved-response-${index}`, snapshotMissing: true });
  });
  return rows;
};

export const selectedOptionLabel = (value, question) => {
  const options = Array.isArray(question.options) ? question.options : [];
  const key = String(value);
  const optionLabel = option => typeof option === 'string' ? option : option?.text ?? option?.label;
  const saved = options.find(option => option && ((hasValue(option.id) && String(option.id) === key) || optionLabel(option) === value));
  if (saved) return displayValue(optionLabel(saved));
  // Older questions used their array index instead of an option id.
  const indexed = /^\d+$/.test(key) ? options[Number(key)] : null;
  if (indexed && !indexed.id) return displayValue(optionLabel(indexed));
  return `Saved option: ${displayValue(value)}`;
};